module.exports = __webpack_public_path__ + "static/media/step-forward.8735d42b.svg";